import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import {
  STORE_ARGENTINA_FIND,
  STORE_ARGENTINA_FIND_SUCCESS,
  STORE_ARGENTINA_UPDATE_LOADING,
  STORE_ARGENTINA_FAILURE,
} from '@store/actions';
import { StoreArgentinaService } from '@core/services';

@Injectable()
export class StoreArgentinaEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private storeArgentinaService: StoreArgentinaService
  ) {}

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STORE_ARGENTINA_FIND),
      mergeMap(({cuit}) => {
        this.store.dispatch(STORE_ARGENTINA_UPDATE_LOADING({  loading: true }));

        return this.storeArgentinaService.getStates(cuit).pipe(
          mergeMap(({ data }) => {
            const storeArgentina = data;

            return [
              STORE_ARGENTINA_FIND_SUCCESS({ storeArgentina }),
              STORE_ARGENTINA_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) => {
            return [
              STORE_ARGENTINA_UPDATE_LOADING({ loading: false }),
              STORE_ARGENTINA_FAILURE({ error })
            ]
          })
        )
      }),
    )
  );
}
